import React from "react";
import { useDeleteOrderDetailContext } from "./providers/Delete";
import { useAppContext } from "../../AppProvider";
import { dictionary } from "../../utilities/dictionary";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonDelete } from "../../Components/common/Buttons/ButtonDelete";

const Delete = () => {
  const { dictionary } = useAppContext();

  const context = useDeleteOrderDetailContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label className="label-4 text-center">
            {dictionary.actions.confirm_deletion}
          </label>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <label className="label-5 text-center">
            {context.orderDetails?.length > 1
              ? `${dictionary.messages.ask_confirm_deletion} ${context.orderDetails?.length} ${dictionary.words.items}?`
              : `${dictionary.messages.ask_confirm_deletion}?`}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (context.callback) {
              context.callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => context.deleteOrderDetails()}
          disabled={context.orderDetailsLoader}
          loading={context.orderDetailsLoader}
        />
      </div>
    </React.Fragment>
  );
};

export default Delete;
